module.exports = __webpack_public_path__ + "img/banner-center.57326b44.jpeg";